import gql from "graphql-tag";

export const CREATE_NEW_TITULAR = gql`
  mutation CrearTitular(
    $titulo_noticia: String!
    $fecha_noticia: String!
    $id_estado: Int!
  ) {
    CrearTitular(
      titulo_noticia: $titulo_noticia
      fecha_noticia: $fecha_noticia
      id_estado: $id_estado
    ) {
      id_noticia
      titulo_noticia
      fecha_noticia
      id_estado
    }
  }
`;

export const UPDATE_NEW_TITULAR = gql`
  mutation UpdateTitular(
    $id_noticia: Int!
    $titulo_noticia: String!
    $fecha_noticia: String!
  ) {
    UpdateTitular(
      id_noticia: $id_noticia
      titulo_noticia: $titulo_noticia
      fecha_noticia: $fecha_noticia
    ) {
      id_noticia
      titulo_noticia
      fecha_noticia
      id_estado
    }
  }
`;

export const CHANGE_STATE_NEW_TITULAR = gql`
  mutation CambiarEstadoTitular($id_noticia: Int!, $id_estado: Int!) {
    CambiarEstadoTitular(id_noticia: $id_noticia, id_estado: $id_estado) {
      id_noticia
      titulo_noticia
      fecha_noticia
      id_estado
    }
  }
`;
// --- ModalRRSS ---
export const SAVE_FEED_LIST = gql`
  mutation CrearListaNoticias ($nombre_lista: String!) {
    CrearListaNoticias(nombre_lista: $nombre_lista) {
      id_lista
      nombre_lista
      id_estado_fk
      id_empresa_fk
      noticias {
        id_lista_fk
        id_lista_noticia
        orden
        n_rss {
          id_noticia
          titulo
          fecha
        }
        n_feed {
          id_noticia
          titulo
          fecha
        }
      }
    }
  }
`;

/*
Respuesta:
{
  "data": {
    "CrearListaNoticias": {
      "id_lista": 3,
      "nombre_lista": "Prueba inicial",
      "id_estado_fk": 1,
      "id_empresa_fk": 1,
      "noticias": null
    }
  }
}
*/

/**
 * NuevaNoticia
 * {
 *  id_noticia_interna Int
 *  id_noticia_rss Int
 *  titulo String
 * }
 */
export const UPDATE_FEED_LIST = gql`
  mutation UpdateListaNoticia(
    $id_lista: Int!
    $nombre_lista: String!
    $noticias: [NuevaNoticia!]!
  ) {
    UpdateListaNoticia(
      id_lista: $id_lista
      nombre_lista: $nombre_lista
      noticias: $noticias
    ) {
      id_lista
      id_estado_fk
      id_empresa_fk
      noticias {
        id_lista_fk
        id_lista_noticia
        orden
        n_rss {
          id_noticia
          titulo
          fecha
        }
        n_feed {
          id_noticia
          titulo
          fecha
        }
      }
      nombre_lista
    }
  }
`;
/*
Respuesta:
{
  "data": {
    "UpdateListaNoticia": {
      "id_lista": 3,
      "id_estado_fk": 1,
      "id_empresa_fk": 1,
      "noticias": [
        {
          "id_lista_fk": 3,
          "id_lista_noticia": 28,
          "orden": 2,
          "n_rss": null,
          "n_feed": {
            "id_noticia": "329",
            "titulo": "Día de la Bandera chilena: ¿qué significan sus colores y por qué tantos países también los tienen?",
            "fecha": "2025-07-10T04:00:00.000Z"
          }
        },
        {
          "id_lista_fk": 3,
          "id_lista_noticia": 27,
          "orden": 1,
          "n_rss": null,
          "n_feed": {
            "id_noticia": "358",
            "titulo": "Prueba titular",
            "fecha": "2025-07-30T01:31:44.050Z"
          }
        }
      ],
      "nombre_lista": "Prueba validando textos"
    }
  }
}
*/

export const DELETE_FEED_LIST = gql`
  mutation DeleteListaNoticia($id_lista: Int!) {
    DeleteListaNoticia(id_lista: $id_lista) {
      id_lista
      nombre_lista
      id_estado_fk
      id_empresa_fk
    }
  }
`;
/*
Respuesta:
{
  "data": {
    "DeleteListaNoticia": {
      "id_lista": 5,
      "nombre_lista": "Prueba eliminando",
      "id_estado_fk": 2,
      "id_empresa_fk": 1
    }
  }
}
*/
